var React = require('react');

function ReportOutageSymbol (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".path-a{fill:#f06d06;}.path-b{fill:none;stroke:#f06d06;}")),React.createElement("g",{"transform":"translate(-17.378 -10.231)","key":1},[React.createElement("path",{"className":"path-a","d":"M2663.462,2091.823l-5.541,7.417,1.4-11.161-9.171-.6,3.981-5.194Z","transform":"translate(-2628.631 -2059.307)","key":0}),React.createElement("path",{"className":"path-a","d":"M2655.977,2079.191l6.279-7.966-1.308,11.509,9.243.276-4.118,5.823Z","transform":"translate(-2627.742 -2060.995)","key":1}),React.createElement("path",{"className":"path-b","d":"M2646.861,2072.629l28.293,27.628","transform":"translate(-2629.134 -2060.78)","key":2})])]);
}

ReportOutageSymbol.defaultProps = {"width":"28.992","height":"29.703","viewBox":"0 0 28.992 29.703"};

module.exports = ReportOutageSymbol;

ReportOutageSymbol.default = ReportOutageSymbol;
